<template>
  <div class="socials">
    <a class="contacts-item-link" href="tel:+375447228833">
      +375 44 722-88-33
    </a>

    <a :href="telegramLink" target="_blank" rel="noopener noreferrer">
      <Telegram class="icon" color="#4CA9D5" />
    </a>

    <a :href="viberLink" target="_blank" rel="noopener noreferrer">
      <Viber class="icon" color="#8C7ACE" />
    </a>
  </div>
</template>

<script>
import Telegram from "@/assets/icons/telegram.svg";
import Viber from "@/assets/icons/viber.svg";
import { telegramLink, viberLink } from "@/utils/constants/socialLinks";

export default {
  name: "SocialIcons",
  components: { Telegram, Viber },
  data() {
    return {
      telegramLink,
      viberLink,
    };
  },
};
</script>

<style scoped lang="less">
.socials {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 70vh;
  right: calc((100vw - 1920px) / 2 + 36px);
  z-index: 100;
  gap: 15px;
  @media (max-width: 1920px) {
    right: 36px;
  }
  @media (max-width: 1439px) {
    position: static;
    flex-direction: row;
    gap: 24px;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
  }
  @media (max-width: 767px) {
    display: none;
  }

  .contacts-item-link {
    font-family: Montserrat;
    font-weight: 500;
    font-size: 24px;
    color: white;
    text-decoration: none;
    display: none;
    &:hover {
      color: #a5d8ff;
    }
    @media (min-width: 768px) and (max-width: 1439px) {
      display: block;
    }
  }

  .icon {
    transition: color 0.2s ease, fill 0.2s ease;
  }
}
</style>
